import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const LoaderWrapper = styled(Box)(({ theme }) => ({
  height: `calc(100vh - ${theme.spacing(20.2)})`,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(3),
}));
